import { styled } from 'styled-components';

const AI_TAG_TEXT_COLOR = '#f9b9ff';

export const TagWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(3)}px;
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing()}px;
`;

export const TagText = styled.span`
  font-size: ${({ theme }) => theme.font.size.md}rem;
  color: ${AI_TAG_TEXT_COLOR};
  line-height: 1;
  font-weight: ${({ theme }) => theme.font.default.weight.bold};
  letter-spacing: 0.02em;
  position: relative;
  bottom: 2px;
  background-image: linear-gradient(355deg, #7e25c4, #f50182);
  background-clip: text;
  color: transparent;
`;
